/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Flow_Remove_ItemInputs */

const en_task_flow_remove_item = /** @type {(inputs: Task_Flow_Remove_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove item`)
};

const pt_br2_task_flow_remove_item = /** @type {(inputs: Task_Flow_Remove_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remover item`)
};

/**
* | output |
* | --- |
* | "Remove item" |
*
* @param {Task_Flow_Remove_ItemInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_flow_remove_item = /** @type {((inputs?: Task_Flow_Remove_ItemInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Flow_Remove_ItemInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_flow_remove_item(inputs)
	return pt_br2_task_flow_remove_item(inputs)
});